import { apiRequest } from "./client";

export const shippingApi = {
  get(projectId) {
    return apiRequest(`/projects/${encodeURIComponent(projectId)}/shipping`);
  },
  save(projectId, config) {
    return apiRequest(`/projects/${encodeURIComponent(projectId)}/shipping`, {
      method: "PUT",
      body: JSON.stringify(config),
    });
  },
};
